import { todayEndToUnix, todayStartToUnix } from 'utils';
import { applyManyNewData } from '../redux/data-actions';
import memoizeOne from 'memoize-one';
import { throttle } from 'throttle-debounce';
export const getPeriod = () => (dispatch, getState) => {
    const period = getState().period;
    if (period.mintime == null || period.maxtime == null) {
        return { mintime: todayStartToUnix(), maxtime: todayEndToUnix() };
    }
    return period;
};
/**
 * @function get_debounce_delay - Выбираем задержку для обновления данных
 * @param period - выбранный период
 * Если выбрали 1 день и меньше, то каждую секунду
 * Если выбрали 2 дня и меньше, то каждые 5 секунд
 * Если выбрали Неделю и меньше, то каждые 10 секунд
 * Если выбрали больше недели, то каждые 30 секунд
 * @return number
 */
export function get_debounce_delay(period) {
    if (period == null || period.mintime == null || period.maxtime == null) {
        return 1e3;
    }
    const delta = period.maxtime - period.mintime;
    if (delta < 86400) {
        return 1e3;
    }
    if (delta < 2 * 86400) {
        return 5e3;
    }
    if (delta < 7 * 86400) {
        return 10e3;
    }
    return 30e3;
}
let new_data_buffer = {};
const createThrottle = memoizeOne((delay, dispatch) => throttle(delay, () => {
    if (dispatch != null) {
        try {
            dispatch(applyManyNewData(new_data_buffer));
        }
        finally {
            new_data_buffer = {};
        }
    }
}));
const debounced_handle_new_data = (dispatch) => {
    const period = dispatch(getPeriod());
    return createThrottle(get_debounce_delay(period), dispatch)();
};
export function processNewData(msg, dispatch) {
    const device_id = msg.device_id;
    if (device_id in new_data_buffer) {
        new_data_buffer[device_id].push(msg);
    }
    else {
        new_data_buffer[device_id] = [msg];
    }
    debounced_handle_new_data(dispatch);
}
